import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const ChevronUp_xs = (props) => {
    const width = props.width ? props.width + 'px' : '16px';
    const height = props.height ? props.height + 'px' : '16px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 16 16"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.5303 11.5303C14.2374 11.8232 13.7626 11.8232 13.4697 11.5303L8 6.06066L2.53033 11.5303C2.23744 11.8232 1.76256 11.8232 1.46967 11.5303C1.17678 11.2374 1.17678 10.7626 1.46967 10.4697L7.46967 4.46967C7.61032 4.32902 7.80109 4.25 8 4.25C8.19891 4.25 8.38968 4.32902 8.53033 4.46967L14.5303 10.4697C14.8232 10.7626 14.8232 11.2374 14.5303 11.5303Z"
            />
        </SvgStyled>
    );
};

export default ChevronUp_xs;
